export const MAIN_SITE_URL = 'https://vkqr.ru';
